import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {
  SignatoryListPure,
  NotificationPure,
  DialogSystemGLPure,
  SequentialSigner,
  DialogTermsCond,
} from "../../pures";
import DialogSignerContainer from "../../pures/signatory-list/dialog-signer";
import DialogPdf from "../../pures/signature-request-detail/dialog-pdf";
import DialogDeleteSignerPure from "../../pures/dialog-delete-signer/dialog-delete-signer.pure";
import { LocalStorageService } from "../../../services";
import { FormDatePicker } from "../../pures";
import { Traslates } from "../../pures";
import { b64toBlob } from "./../../../validators";
import "./signature-request.css";

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <strong>{props.title}</strong>
      <p>{props.content}</p>
      <p>{props.subContent}</p>
      <p>{props.restContent}</p>
    </a>
  );
};

function SignatureRequestView(props) {
  let {
    signatureTypesInputValue,
    setSignatureTypes,
    setProcessTypes,
    processTypesInputValue,
  } = props;

  const [currentSystem, setCurrentSystem] = useState("");
  const { t } = useTranslation();
  const [blobUrl, setBlobUrl] = useState("");
  const [isAddStakehoderActive, setIsAddStakehoderActive] = useState(false);
  const [isAddValidatorActive, setIsAddValidatorActive] = useState(false);
  const [isAddGuestActive, setIsAddGuestActive] = useState(false);
  const [modalTermsCond, setModalTermsCond] = useState(null);
  
  let localStorageService = new LocalStorageService()
  let preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    if (props.signers.find((i) => !i.email))
      props.setSigners(props.signers.filter((i) => !!i.email));
    if (props.validators.find((i) => !i.email))
      props.setValidators(props.validators.filter((i) => !!i.email));
  }, [props.signers, props.validators]);

  useEffect(() => {
    if (props.signatureTypes.length > 0) {
      setSignatureTypes(
        props.signatureTypes.map((item) => ({ ...item, isActive: false }))
      );
    }

    if (props.processTypes.length > 0) {
      setProcessTypes(
        props.processTypes.map((item) => ({ ...item, isActive: false }))
      );
    }
  }, [props.signatureTypes, props.processTypes]);

  useEffect(() => {
    if (props.selectedFileBase64) {
      const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
      setBlobUrl(blob);
    }
  }, [props.selectedFileBase64]);

  useEffect(() => {
    setIsAddStakehoderActive(false);
    setIsAddGuestActive(false);
    setIsAddValidatorActive(false);
  }, [props.signers.length]);

  useEffect(() => {
    if (!props.signerInEdit) {
      setIsAddGuestActive(false);
      setIsAddValidatorActive(false);
      setIsAddStakehoderActive(false);
    }
  }, [props.signerInEdit]);

  useEffect(() => {
    if (props.firmante) {
      let id_order = "";
      const element = props.signers.length;
      id_order = element + 1;
      props.selectSigner({
        nameSigner: props.userInformationFirstName,
        lastNameSigner: `${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
        email: props.userInformationEmail,
        type: Number(process.env.REACT_APP_SIGNERS_TYPE_ADMINISTRADOR),
        typeName: "Administrador",
        id_order,
      });
    }
  }, [props.firmante]);

  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    justifyContent: "flex-start",
    marginBottom: "20px",
    width: "auto",
    maxWidth: "100%",
    backgroundColor: "white",
    boxShadow: "1px 1px 3px #959595",
    // marginRight: '105px',
  };

  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }
  const containerInputsFileAndCommnetsStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
  };
  const gridContainercheckboxAndInputDateStyles = {
    paddingTop: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  };
  const gridContainerTableSignersStyles = {
    display: "flex",
    alignItems: "center",
    marginBottom: "32px",
    marginTop: "32px",
    flexWrap: "wrap",
  };
  const iconTooltipStyles = {
    color: "#4F690C",
    fontSize: "23px",
    marginLeft: "5px",
    padding: "5px",
    cursor: "pointer",
    maxWidth: "205px",
  };

  // Get a list of collaborators based on a provided text
  const getCollaborator = async (value) => {
    let results = [];
    for (let i = 0; i < props.collaboratorListAllow.length; i++) {
      let emailExtract = props.collaboratorListAllow[i].email
        .split("@")[0]
        .toLowerCase();
      let addEmail = emailExtract.includes(value.trim().toLowerCase());
      if (addEmail === true) results.push(props.collaboratorListAllow[i].email);
    }
    return results;
  };

  // Get a list of guest based on a provided text
  const getGuestName = async (value) => {
    let results = [];
    for (let i = 0; i < props.inviteListAllow.length; i++) {
      let emailExtract = props.inviteListAllow[i].email
        .split("@")[0]
        .toLowerCase();
      let addEmail = emailExtract.includes(value.trim().toLowerCase());
      if (addEmail === true) results.push(props.inviteListAllow[i].email);
    }
    return results;
  };

  const handleSignaturesTypes = (params, index) =>
    setSignatureTypes(
      signatureTypesInputValue.map((j, i) =>
        i === index
          ? { ...j, isActive: params.value }
          : { ...j, isActive: false }
      )
    );
  const handleProcessTypes = (params, index) => {
    setProcessTypes(
      processTypesInputValue.map((j, i) =>
        i === index
          ? { ...j, isActive: params.value }
          : { ...j, isActive: false }
      )
    );
    props.resetNotErrors();
  };
  const handleSelectservices = (params, index) =>
    props.setServices(
      props.services.map((j, i) =>
        i === index ? { ...j, isActive: params.value } : { ...j }
      )
    );
  const openModalTermsCond = (value) => {
    setModalTermsCond(value);
  };

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open);
  const hiddeTooltip = () => setOpen(false);

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }
  let isSignatureTypeSelected = signatureTypesInputValue.find(
    (i) => i.isActive
  );
  let isAtgrafSignature =
    String((isSignatureTypeSelected || {}).id) ===
    String(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA);
  const isMobileSize = useMediaQuery("(max-width:530px)");
  const hideChecks = isMobileSize && isAtgrafSignature;

  return (
    <div className="requestView">
      <Container style={globalContainerStyles} lg={12} md={12} sm={12} es={12}>
        <div className="full-container">
          {/* Header H3 */}
          <div style={{ marginTop: "3px" }}>
            <div style={{ height: "3px", width: "100px" }} />
            <div className="signature-request-wrapper title">
              <h3>{t("signatureRequestView2.titleNewRequest")}</h3>
            </div>
          </div>

          {/* Form container */}
          <div className="form-container">
            <Form
              initialValues={{
                name: props.name,
                description: props.description,
              }}
              allowSubmit={true}
              valid={true}
              onSubmit={props.onSubmit}
              render={(formRenderProps) => {
                return (
                  <FormElement style={{ width: "100%" }}>
                    <fieldset className={"k-form-fieldset fieldset"}>
                      {/* General container form */}
                      <Grid style={{ width: "100%" }}>
                        {/* Container labels name, descripcion */}
                        <Grid container lg={12} md={12}>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            className="container-form-signRequest"
                          >
                            <Tooltip
                              position="right"
                              anchorElement="target"
                              content={(props) => {
                                return (
                                  <TooltipContentTemplate
                                    title={
                                      open
                                        ? t(
                                          "signatureRequestView2.toolTipFirst"
                                        )
                                        : props.title
                                    }
                                    content={
                                      open
                                        ? t(
                                          "signatureRequestView2.tooltipFirstDetail"
                                        )
                                        : ""
                                    }
                                  />
                                );
                              }}
                            >
                              <Label
                                className="form-inputs-labels"
                                style={{ maxWidth: "205px" }}
                              >
                                {t("signatureRequestView2.nameRequest")}
                                <i
                                  className="k-icon k-i-information"
                                  style={iconTooltipStyles}
                                  title={t("signatureRequestView2.tooltipClic")}
                                  onClick={() => handleOnChangeTooltip()}
                                  onMouseOut={() => hiddeTooltip()}
                                />
                              </Label>
                            </Tooltip>
                            <Field
                              name={"name"}
                              id={"name"}
                              component={props.validateInput}
                              validator={props.validator.nameValidator}
                              className="form-inputs-inputs-text k-textbox max-width"
                              onBlur={props.onValidaNameUnique}
                              required
                            />
                            {/* {props.errorNameUnique && <span className='hint-message-error-name'>{t('signatureRequestView2.nameOfSignRequestAlreadyExist')}</span>} */}
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            className="container-form-signRequest"
                          >
                            <Tooltip
                              position="right"
                              anchorElement="target"
                              content={(props) => {
                                return (
                                  <TooltipContentTemplate
                                    title={
                                      open
                                        ? t(
                                          "signatureRequestView2.tooltipDescriptionDocument"
                                        )
                                        : props.title
                                    }
                                    content={
                                      open
                                        ? t(
                                          "signatureRequestView2.tooltipDescriptionDocumentDes"
                                        )
                                        : ""
                                    }
                                  />
                                );
                              }}
                            >
                              <Label className="form-inputs-labels">
                                {t("signatureRequestView2.descriptionSign")}
                                <i
                                  className="k-icon k-i-information"
                                  style={iconTooltipStyles}
                                  title={t("signatureRequestView2.tooltipClic")}
                                  onClick={() => handleOnChangeTooltip()}
                                  onMouseOut={() => hiddeTooltip()}
                                />
                              </Label>
                            </Tooltip>
                            <div className="textarea-continer">
                              <div className="textarea-coments">
                                <textarea
                                  className="form-inputs-textarea"
                                  validator={props.validator.nameValidator}
                                  onChange={(e) => {
                                    props.onChangeSummaryDescription(e);
                                  }}
                                  value={props.description}
                                  required
                                />
                                {props.errorCurrentDescription && (
                                  <span className="hint-message-error">
                                    {t(
                                      "signatureRequestView2.extentionPDFNotValid"
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            className="container-form-signRequest"
                          >
                            <Tooltip
                              position="right"
                              anchorElement="target"
                              content={(props) => {
                                return (
                                  <TooltipContentTemplate
                                    title={
                                      open
                                        ? t(
                                          "signatureRequestView2.tooltipCommentsTitle"
                                        )
                                        : props.title
                                    }
                                    content={
                                      open
                                        ? t(
                                          "signatureRequestView2.tooltipCommentsDescription"
                                        )
                                        : ""
                                    }
                                  />
                                );
                              }}
                            >
                              <Label className="form-inputs-labels">
                                {t("signatureRequestView2.addComments")}
                                <i
                                  className="k-icon k-i-information"
                                  style={iconTooltipStyles}
                                  title={t("signatureRequestView2.tooltipClic")}
                                  onClick={() => handleOnChangeTooltip()}
                                  onMouseOut={() => hiddeTooltip()}
                                />
                              </Label>
                            </Tooltip>
                            <div className="textarea-continer">
                              <div className="textarea-coments">
                                <textarea
                                  className="form-inputs-textarea"
                                  onChange={(e) => {
                                    props.onChangeComments(e);
                                  }}
                                  value={props.comments}
                                />
                              </div>
                            </div>
                          </Grid>
                        </Grid>

                        {/* Container for Render PDF, inpus terms and conditions and input limit date */}
                        <Grid
                          container
                          lg={12}
                          md={12}
                          sm={12}
                          es={12}
                          className="container-form-signRequest"
                        >
                          <Grid
                            container
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            style={containerInputsFileAndCommnetsStyles}
                          >
                            {/* Input File */}
                            <Grid item xs={8} lg={8} md={8} sm={8} es={8}>
                              <div
                                className="form-inputs-box"
                                xs={8}
                                lg={8}
                                md={8}
                                sm={8}
                                es={8}
                              >
                                <Label className="form-inputs-labels-uno">
                                  {t("signatureRequestView2.uploadDocument")}
                                </Label>
                                <div className="style-document">
                                  <div
                                    className="custom-input-file"
                                    xs={8}
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    es={8}
                                  >
                                    <i
                                      className="k-icon k-i-plus"
                                      style={{ fontSize: "20px" }}
                                    ></i>
                                    <input
                                      className="input-file"
                                      type="file"
                                      accept="application/pdf"
                                      id="file"
                                      onClick={(e) => (e.target.value = null)}
                                      onChange={(e) => {
                                        props.handleFile(e);
                                      }}
                                    />
                                    {t("signatureRequestView2.pdf")}
                                  </div>
                                  <div
                                    onClick={() => {
                                      props.handleDeleteFile();
                                    }}
                                    className="button-sign-request-delete"
                                    xs={8}
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    es={8}
                                  >
                                    <i
                                      title={"tooltipDelete"}
                                      className="k-icon k-i-delete k-i-trash"
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                            <Grid item xs={8} lg={8} md={8} sm={8} es={8}>
                              <div
                                className="form-inputs-box"
                                xs={8}
                                lg={8}
                                md={8}
                                sm={8}
                                es={8}
                              >
                                <div
                                  className={`form-inpust-file-leyend ${props.colorBorderContainer}`}
                                  xs={8}
                                  lg={8}
                                  md={8}
                                  sm={8}
                                  es={8}
                                >
                                  <p className="form-inpust-file-leyend-name">
                                    {!props.selectedFile
                                      ? `${t(
                                        "signatureRequestView2.notuploadDocument"
                                      )}`
                                      : `${props.selectedFileName}`}
                                  </p>
                                </div>
                                <span className="form-inpust-file-leyend-icon">
                                  {props.selectedFile && (
                                    <i className="k-icon k-i-check-circle k-i-checkmark-circle"></i>
                                  )}
                                </span>
                              </div>
                              {props.errorFile && (
                                <span className="hint-message-error">
                                  {t(
                                    "signatureRequestView2.extentionPDFNotValid"
                                  )}
                                </span>
                              )}
                            </Grid>
                          </Grid>

                          {/* Display PDF, checkbox terms and conditios and input limit date */}
                          <Grid
                            className="pdf-container"
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                          >
                            {props.selectedFile && (
                              <React.Fragment>
                                {!isMobile && (
                                  <Grid
                                    className="pdf-embed"
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    es={12}
                                  >
                                    <embed type="application/pdf" name="document_pdf" src={blobUrl} className="canvas_container_pdf_render" />
                                    {/* <iframe
                                      name="document_pdf"
                                      id="myiframe"
                                      src={
                                        props.selectedFileBase64
                                          ? "data:application/pdf;base64," +
                                          props.selectedFileBase64 + "#toolbar=0"
                                          : null
                                      }
                                      className="canvas_container_pdf_render"
                                    /> */}


                                  </Grid>
                                )}
                                {isMobile && (
                                  <div className="pdf-btn">
                                    <DialogPdf blobUrl={blobUrl} />
                                  </div>
                                )}
                              </React.Fragment>
                            )}
                            {props.selectedFile && (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                style={gridContainercheckboxAndInputDateStyles}
                              >
                                <Grid
                                  item
                                  lg={6}
                                  md={6}
                                  es={12}
                                  style={{
                                    lineHeight: "0.8rem",
                                    width: "100%",
                                  }}
                                >
                                  <Field
                                    id={"document"}
                                    name={"document"}
                                    label={t(
                                      "signatureRequestView2.acceptUploadDocumentLegal"
                                    )}
                                    component={Checkbox}
                                    onChange={props.handleChangeCheckbox}
                                  />
                                  <p className="form-inputs-terms-conditions">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        openModalTermsCond(true);
                                      }}
                                    >
                                      {t(
                                        "signatureRequestView2.termsConditions"
                                      )}
                                    </a>
                                  </p>
                                  {props.errorAcceptDocument && (
                                    <span className="hint-message-error">
                                      {t(
                                        "signatureRequestView2.acceptUploadDocument"
                                      )}
                                    </span>
                                  )}
                                </Grid>

                                <Grid item lg={6} md={6} es={12}>
                                  <Tooltip
                                    position="right"
                                    anchorElement="target"
                                    content={(props) => {
                                      return (
                                        <TooltipContentTemplate
                                          title={
                                            open
                                              ? t(
                                                "signatureRequestView2.tooltipLimit"
                                              )
                                              : props.title
                                          }
                                          content={
                                            open
                                              ? t(
                                                "signatureRequestView2.tooltipLimitDateDescription"
                                              )
                                              : ""
                                          }
                                        />
                                      );
                                    }}
                                  >
                                    <Label className="form-inputs-labels">
                                      {t("signatureRequestView2.limitDate")}
                                      <i
                                        className="k-icon k-i-information"
                                        style={iconTooltipStyles}
                                        title={t(
                                          "signatureRequestView2.tooltipClic"
                                        )}
                                        onClick={() => handleOnChangeTooltip()}
                                        onMouseOut={() => hiddeTooltip()}
                                      />
                                    </Label>
                                  </Tooltip>
                                  <Traslates>
                                    <Field
                                      id={"limitDate"}
                                      name={"limitDate"}
                                      format="dd/MM/yyyy"
                                      min={props.date}
                                      component={FormDatePicker}
                                      validator={
                                        props.validator.limitDateValidator
                                      }
                                      required={true}
                                    // title={t('signatureRequestView2.tooltipLimitDate')}
                                    />
                                  </Traslates>
                                </Grid>

                                {/* Checkboxes aditional services */}
                                <Grid
                                  item
                                  style={{
                                    marginTop: "20px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <Tooltip
                                    position="right"
                                    anchorElement="target"
                                    content={(props) => {
                                      return (
                                        <TooltipContentTemplate
                                          title={
                                            open
                                              ? t(
                                                "signatureRequestView2.services"
                                              )
                                              : props.title
                                          }
                                          content={
                                            open
                                              ? t(
                                                "signatureRequestView2.servicesDetail"
                                              )
                                              : ""
                                          }
                                        />
                                      );
                                    }}
                                  >
                                    <Label className="form-inputs-labels">
                                      {t(
                                        "signatureRequestView2.aditionalServices"
                                      )}
                                      <i
                                        className="k-icon k-i-information"
                                        style={iconTooltipStyles}
                                        title={t(
                                          "signatureRequestView2.tooltipClic"
                                        )}
                                        onClick={() => handleOnChangeTooltip()}
                                        onMouseOut={() => hiddeTooltip()}
                                      />
                                    </Label>
                                  </Tooltip>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {props.services.map((item, index) => {
                                      return (
                                        <React.Fragment key={String(item.id)}>
                                          <div
                                            style={{
                                              marginRight: "15px",
                                              display: "flex",
                                              flexDirection: "row",
                                            }}
                                          >
                                            <Checkbox
                                              style={{ marginRight: "10px" }}
                                              checked={item.isActive}
                                              label={""}
                                              onChange={(params) =>
                                                handleSelectservices(
                                                  params,
                                                  index
                                                )
                                              }
                                            />
                                            <a
                                              onClick={() =>
                                                handleSelectservices(
                                                  { value: !item.isActive },
                                                  index
                                                )
                                              }
                                            >
                                              <label
                                                style={{ cursor: "pointer" }}
                                              >
                                                {item.name}
                                              </label>
                                            </a>
                                          </div>
                                        </React.Fragment>
                                      );
                                    })}
                                  </div>
                                </Grid>
                                {/* Checkboxes signerType */}
                                {!!props.selectedFile && (
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    es={8}
                                    style={{
                                      marginTop: "20px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div>
                                      <Tooltip
                                        position="right"
                                        anchorElement="target"
                                        content={(props) => {
                                          return (
                                            <TooltipContentTemplate
                                              title={
                                                open
                                                  ? t(
                                                    "signatureRequestView2.tooltipSignatureTypes"
                                                  )
                                                  : props.title
                                              }
                                              content={
                                                open
                                                  ? t(
                                                    "signatureRequestView2.tooltipSignatureTypesOne"
                                                  )
                                                  : ""
                                              }
                                              subContent={
                                                open
                                                  ? t(
                                                    "signatureRequestView2.tooltipSignatureTypesTwo"
                                                  )
                                                  : ""
                                              }
                                              restContent={
                                                open
                                                  ? t(
                                                    "signatureRequestView2.tooltipSignatureTypeThree"
                                                  )
                                                  : ""
                                              }
                                            />
                                          );
                                        }}
                                      >
                                        <Label className="form-inputs-labels">
                                          {t(
                                            "signatureRequestView2.signatureTypes"
                                          )}
                                          <i
                                            className="k-icon k-i-information"
                                            style={iconTooltipStyles}
                                            title={t(
                                              "signatureRequestView2.tooltipClic"
                                            )}
                                            onClick={() =>
                                              handleOnChangeTooltip()
                                            }
                                            onMouseOut={() => hiddeTooltip()}
                                          />
                                        </Label>
                                      </Tooltip>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {signatureTypesInputValue.map(
                                          (item, index) => {
                                            return (
                                              <React.Fragment
                                                key={String(item.id)}
                                              >
                                                <div
                                                  style={{
                                                    marginRight: "15px",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                  }}
                                                >
                                                  <Checkbox
                                                    style={{
                                                      marginRight: "10px",
                                                    }}
                                                    checked={item.isActive}
                                                    label={""}
                                                    onChange={(params) =>
                                                      handleSignaturesTypes(
                                                        params,
                                                        index
                                                      )
                                                    }
                                                  />
                                                  <a
                                                    onClick={() =>
                                                      handleSignaturesTypes(
                                                        {
                                                          value: !item.isActive,
                                                        },
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <label
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      {item.name}
                                                    </label>
                                                  </a>
                                                </div>
                                              </React.Fragment>
                                            );
                                          }
                                        )}
                                      </div>
                                      {props.errorSignatureTypeId && (
                                        <span className="hint-message-error-name">
                                          {t(
                                            "signatureRequestView2.slectedTypeOfSignature"
                                          )}
                                        </span>
                                      )}
                                    </div>
                                  </Grid>
                                )}
                                {/* Checkboxes signatureFlow */}
                                {props.processTypesInputValue && (
                                  <Grid
                                    item
                                    style={{
                                      marginTop: "20px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <Tooltip
                                      position="right"
                                      anchorElement="target"
                                      content={(props) => {
                                        return (
                                          <TooltipContentTemplate
                                            title={
                                              open
                                                ? t(
                                                  "signatureRequestView2.flowSignatures"
                                                )
                                                : props.title
                                            }
                                            content={
                                              open
                                                ? t(
                                                  "signatureRequestView2.flowSignaturesDetail"
                                                )
                                                : ""
                                            }
                                            subContent={
                                              open
                                                ? t(
                                                  "signatureRequestView2.flowSignaturesRest"
                                                )
                                                : ""
                                            }
                                          />
                                        );
                                      }}
                                    >
                                      <Label className="form-inputs-labels">
                                        {t(
                                          "signatureRequestView2.signatureFlow"
                                        )}
                                        <i
                                          className="k-icon k-i-information"
                                          style={iconTooltipStyles}
                                          title={t(
                                            "signatureRequestView2.tooltipClic"
                                          )}
                                          onClick={() =>
                                            handleOnChangeTooltip()
                                          }
                                          onMouseOut={() => hiddeTooltip()}
                                        />
                                      </Label>
                                    </Tooltip>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {props.processTypesInputValue.map(
                                        (item, index) => {
                                          return (
                                            <React.Fragment
                                              key={String(item.id)}
                                            >
                                              <div
                                                style={{
                                                  marginRight: "15px",
                                                  display: "flex",
                                                  flexDirection: "row",
                                                }}
                                              >
                                                <Checkbox
                                                  style={{
                                                    marginRight: "10px",
                                                  }}
                                                  checked={item.isActive}
                                                  label={""}
                                                  onChange={(params) =>
                                                    handleProcessTypes(
                                                      params,
                                                      index
                                                    )
                                                  }
                                                />
                                                <a
                                                  onClick={() =>
                                                    handleProcessTypes(
                                                      { value: !item.isActive },
                                                      index
                                                    )
                                                  }
                                                >
                                                  <label
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {item.name}
                                                  </label>
                                                </a>
                                              </div>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </div>
                                  </Grid>
                                )}
                              </Grid>
                            )}
                          </Grid>
                        </Grid>

                        {/* Button signers and Table signers */}

                        <Grid container lg={12} md={12} sm={12} es={12}>
                          {props.processTypeId && (
                            <Grid
                              className="add-btns"
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              es={12}
                              style={gridContainerTableSignersStyles}
                            >
                              {props.processTypeId === 3 && (
                                <div
                                  className={`form-inputs-button-ad-signersone ${isAddValidatorActive
                                    ? "form-inputs-button-ad-signers-active"
                                    : ""
                                    }`}
                                  onClick={() => {
                                    setIsAddGuestActive(false);
                                    setIsAddStakehoderActive(false);
                                    setIsAddValidatorActive(
                                      !isAddValidatorActive
                                    );
                                    props.insertValidator();
                                  }}
                                >
                                  <span>
                                    <i className="k-icon k-i-plus"></i>
                                    {t("signatureRequestView2.addValidator")}
                                  </span>
                                </div>
                              )}
                              {props.processTypeId === 4 && (
                                <div
                                  className={`form-inputs-button-ad-signersone ${isAddValidatorActive
                                    ? "form-inputs-button-ad-signers-active"
                                    : ""
                                    }`}
                                  onClick={() => {
                                    setIsAddGuestActive(false);
                                    setIsAddStakehoderActive(false);
                                    setIsAddValidatorActive(
                                      !isAddValidatorActive
                                    );
                                    props.insertValidator();
                                  }}
                                >
                                  <span>
                                    <i className="k-icon k-i-plus"></i>
                                    {t("signatureRequestView2.addValidator")}
                                  </span>
                                </div>
                              )}
                              <div
                                className={`form-inputs-button-ad-signersone ${isAddStakehoderActive
                                  ? "form-inputs-button-ad-signers-active"
                                  : ""
                                  }`}
                                onClick={() => {
                                  setIsAddGuestActive(false);
                                  setIsAddValidatorActive(false);
                                  setIsAddStakehoderActive(
                                    !isAddStakehoderActive
                                  );
                                  props.insertCollaborator();
                                }}
                              >
                                <span>
                                  <i className="k-icon k-i-plus"></i>
                                  {t("signatureRequestView2.addCollaborator")}
                                </span>
                              </div>
                              <div
                                className={`form-inputs-button-ad-signersone ${isAddGuestActive
                                  ? "form-inputs-button-ad-signers-active"
                                  : ""
                                  }`}
                                onClick={() => {
                                  setIsAddGuestActive(true);
                                  setIsAddStakehoderActive(false);
                                  setIsAddValidatorActive(false);
                                  props.insert();
                                }}
                              >
                                <span>
                                  <i className="k-icon k-i-plus"></i>
                                  {t("signatureRequestView2.addInvited")}
                                </span>
                              </div>
                              <br />

                              {(props.processTypeId ===
                                Number(
                                  process.env
                                    .REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL
                                ) ||
                                props.processTypeId ===
                                Number(
                                  process.env
                                    .REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL
                                )) && (
                                  <div
                                    style={hideChecks ? { display: "none" } : {}}
                                  >
                                    <Checkbox
                                      style={{
                                        maxWidth: "15px",
                                        maxHeight: "15px",
                                      }}
                                      checked={
                                        !!props.validators.find(
                                          (i) =>
                                            i.email === props.userInformationEmail
                                        )
                                      }
                                      label={t(
                                        "signatureRequestView2.firmanteTVal"
                                      )}
                                      onChange={(params) => {
                                        if (params.value) {
                                          props.setValidators(
                                            props.validators.concat({
                                              nameSigner: `${props.userInformationFirstName} ${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
                                              lastNameSigner: `${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
                                              email: props.userInformationEmail,
                                              type: Number(
                                                process.env
                                                  .REACT_APP_SIGNERS_TYPE_VALIDATOR
                                              ),
                                              typeName: "Administrador",
                                              id_order: 0,
                                            })
                                          );
                                        } else
                                          props.setValidators(
                                            props.validators.filter(
                                              (i) =>
                                                i.email !==
                                                props.userInformationEmail
                                            )
                                          );
                                        props.setSigners(
                                          props.signers.filter(
                                            (i) =>
                                              i.email !==
                                              props.userInformationEmail
                                          )
                                        );
                                      }}
                                    />
                                  </div>
                                )}
                              <br />
                              <div
                                style={
                                  hideChecks
                                    ? { display: "none" }
                                    : (preferredLanguage && preferredLanguage === 	"en") ? { marginLeft: "8px" } : { marginLeft: "0px" }
                                }
                              >
                                <Checkbox
                                  style={{
                                    maxWidth: "15px",
                                    maxHeight: "15px",
                                  }}
                                  checked={
                                    !!props.signers.find(
                                      (i) =>
                                        i.email === props.userInformationEmail
                                    )
                                  }
                                  label={t("signatureRequestView2.firmanteT")}
                                  onChange={(params) => {
                                    if (params.value) {
                                      props.setSigners(
                                        props.signers.concat({
                                          nameSigner: `${props.userInformationFirstName} ${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
                                          lastNameSigner: `${props.userInformationFirstLastName} ${props.userInformationSecondLastName}`,
                                          email: props.userInformationEmail,
                                          type: Number(
                                            process.env
                                              .REACT_APP_SIGNERS_TYPE_ADMINISTRADOR
                                          ),
                                          typeName: "Administrador",
                                          id_order: 0,
                                        })
                                      );
                                    } else
                                      props.setSigners(
                                        props.signers.filter(
                                          (i) =>
                                            i.email !==
                                            props.userInformationEmail
                                        )
                                      );
                                    props.setValidators(
                                      props.validators.filter(
                                        (i) =>
                                          i.email !== props.userInformationEmail
                                      )
                                    );
                                  }}
                                />
                              </div>
                              <br />
                            </Grid>
                          )}

                          {props.errorNotValidators &&
                            props.validators.length === 0 && (
                              <span className="hint-message-error">
                                {t("signatureRequestView2.notAddRequest")}
                              </span>
                            )}
                          {props.errorNotSigners &&
                            props.signers.length === 0 &&
                            isSignatureTypeSelected && (
                              <span className="hint-message-error">
                                {t("signatureRequestView2.notAddRequest")}
                              </span>
                            )}
                          <Grid
                            className="table-add-signers"
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            style={{ marginBottom: "20px", marginLeft: "22px" }}
                          >
                            {props.processTypeId ===
                              Number(
                                process.env
                                  .REACT_APP_SIGNERS_PROCESS_TYPE_RANDOM
                              ) && (
                                <SignatoryListPure
                                  validateInput={props.validateInput}
                                  setSigners={props.setSigners}
                                  isSignatureTypeSelected={
                                    isSignatureTypeSelected
                                  }
                                  isAtgrafSignature={isAtgrafSignature}
                                  signers={props.signers}
                                  toggleDialogDeleteSigner={
                                    props.toggleDialogDeleteSigner
                                  }
                                />
                              )}
                            {props.processTypeId ===
                              Number(
                                process.env
                                  .REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL
                              ) && (
                                <SequentialSigner
                                  validateInput={props.validateInput}
                                  setSigners={props.setSigners}
                                  isSignatureTypeSelected={
                                    isSignatureTypeSelected
                                  }
                                  isAtgrafSignature={isAtgrafSignature}
                                  signers={props.signers.map((item) => ({
                                    ...item,
                                    key: "signers",
                                  }))}
                                  DragCell={props.DragCell}
                                  changeRows={(dataItem, sum) =>
                                    props.changeRows(dataItem, sum, "signers")
                                  }
                                  toggleDialogDeleteSigner={
                                    props.toggleDialogDeleteSigner
                                  }
                                />
                              )}

                            {props.processTypeId ===
                              Number(
                                process.env
                                  .REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL
                              ) && (
                                <React.Fragment>
                                  <Label className="form-inputs-labels">
                                    {"Autorizadores"}
                                  </Label>
                                  <SignatoryListPure
                                    validateInput={props.validateInput}
                                    setSigners={props.setSigners}
                                    isSignatureTypeSelected={
                                      isSignatureTypeSelected
                                    }
                                    signers={props.validators.map((item) => ({
                                      ...item,
                                      key: "validators",
                                    }))}
                                    type={"validators"}
                                    toggleDialogDeleteSigner={
                                      props.toggleDialogDeleteSigner
                                    }
                                  />
                                  <br />
                                  <br />
                                  <br />
                                  <Label className="form-inputs-labels">
                                    {"Firmantes"}
                                  </Label>
                                  <SignatoryListPure
                                    validateInput={props.validateInput}
                                    setSigners={props.setSigners}
                                    isSignatureTypeSelected={
                                      isSignatureTypeSelected
                                    }
                                    isAtgrafSignature={isAtgrafSignature}
                                    type={"validators"}
                                    signers={props.signers}
                                    toggleDialogDeleteSigner={
                                      props.toggleDialogDeleteSigner
                                    }
                                  />
                                </React.Fragment>
                              )}

                            {props.processTypeId ===
                              Number(
                                process.env
                                  .REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL
                              ) && (
                                <React.Fragment>
                                  <Label className="form-inputs-labels">
                                    {t("signatureRequestView2.validator")}
                                  </Label>
                                  <SequentialSigner
                                    validateInput={props.validateInput}
                                    setSigners={props.setSigners}
                                    isSignatureTypeSelected={
                                      isSignatureTypeSelected
                                    }
                                    isAtgrafSignature={isAtgrafSignature}
                                    signers={props.validators.map((item) => ({
                                      ...item,
                                      key: "validators",
                                    }))}
                                    DragCell={props.DragCell}
                                    type={"validators"}
                                    changeRows={(dataItem, sum) =>
                                      props.changeRows(
                                        dataItem,
                                        sum,
                                        "validators"
                                      )
                                    }
                                    toggleDialogDeleteSigner={
                                      props.toggleDialogDeleteSigner
                                    }
                                  />
                                  <br />
                                  <br />
                                  <br />
                                  <Label className="form-inputs-labels">
                                    {t("signatureRequestView2.Signers")}
                                  </Label>
                                  <SignatoryListPure
                                    validateInput={props.validateInput}
                                    setSigners={props.setSigners}
                                    isSignatureTypeSelected={
                                      isSignatureTypeSelected
                                    }
                                    isAtgrafSignature={isAtgrafSignature}
                                    signers={props.signers}
                                    toggleDialogDeleteSigner={
                                      props.toggleDialogDeleteSigner
                                    }
                                  />
                                </React.Fragment>
                              )}
                            {props.signerInEdit && (
                              <DialogSignerContainer
                                {...props}
                                isAtgrafSignature={isAtgrafSignature}
                                validator={props.validator}
                                validateInput={props.validateInput}
                                signerTypes={props.signerTypes}
                                dataItem={props.signerInEdit}
                                save={props.save}
                                cancel={props.cancel}
                                dialogTitle={props.dialogTitle}
                                handleSubmit={props.handleSubmit}
                                onDialogInputChange={props.onDialogInputChange}
                                disableSignerButton={props.disableSignerButton}
                                getGuestName={getGuestName}
                                getCollaborator={getCollaborator}
                              // getNames={getNames}
                              />
                            )}
                          </Grid>
                        </Grid>

                        {/* {(signatureTypesInputValue.find(i => i.id === 3) || {}).isActive && (
                                                    <Grid item xs={8} lg={8} md={8} sm={8} es={8} style={{ marginTop: '20px', marginBottom: '10px' }}>
                                                        <div>
                                                            <Label className="form-inputs-labels" >
                                                                {'¿Uso obligatorio de firma autógrafa e ine?'}
                                                            </Label>
                                                            <div style={{ display: "flex", flexWrap: "wrap", }}>
                                                                <div style={{ marginRight: '15px', display: 'flex', flexDirection: 'row', }}>
                                                                    <Checkbox style={{ marginRight: '10px' }} checked={props.requireSignSupport} label={''} onChange={props.setRequireSignSupport} />
                                                                    <a onClick={props.setRequireSignSupport} >
                                                                        <label style={{ cursor: 'pointer' }} >{'Si'}</label>
                                                                    </a>
                                                                </div>
                                                                <div style={{ marginRight: '15px', display: 'flex', flexDirection: 'row', }}>
                                                                    <Checkbox style={{ marginRight: '10px' }} checked={!props.requireSignSupport} label={''} onChange={props.setRequireSignSupport} />
                                                                    <a onClick={props.setRequireSignSupport} >
                                                                        <label style={{ cursor: 'pointer' }} >{'No'}</label>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            {props.errorSignatureTypeId && <span className='hint-message-error-name'>{t('signatureRequestView2.slectedTypeOfSignature')}</span>}
                                                        </div>
                                                    </Grid>
                                                )} */}
                        {/* Boton Submit */}
                        {!props.selectedFile && (
                          <div
                            style={{ height: "275px", width: "100px" }}
                          ></div>
                        )}
                        <div className="div-btn" style={{ flexWrap: "wrap" }}>
                          <div
                            onClick={() => props.history.goBack()}
                            className="buttonCancelStyles"
                          >
                            <span>
                              {t("signatureRequestView2.cancelDocumentToSign")}
                            </span>
                          </div>
                          <Button
                            type={"submit"}
                            // primary={true}
                            disabled={
                              !(
                                formRenderProps.allowSubmit &&
                                formRenderProps.valid &&
                                !(
                                  isAddGuestActive ||
                                  isAddValidatorActive ||
                                  isAddStakehoderActive
                                )
                              )
                            }
                            onClick={props.scrollWindow}
                            className="buttonSubmitStyles"
                          >
                            {t("signatureRequestView2.sendDocumentToSign")}
                          </Button>
                        </div>
                      </Grid>
                    </fieldset>
                  </FormElement>
                );
              }}
            />
          </div>
        </div>
      </Container>

      {/* Notificacion alert */}
      <NotificationPure
        notification={props.showNotification}
        type={props.notification.type}
        style={props.notification.style}
        onClose={props.onCloseOpenModal}
        message={props.message}
      />

      {/* Alerts of Notification Completed and Loadign */}
      <DialogSystemGLPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
        toggleErrorDomain={props.toggleErrorDomain}
        cancel={props.cancel}
        handleSubmitConfirm={props.handleSubmitConfirm}
      />

      {/* Dialog Delete Signer */}
      <DialogDeleteSignerPure
        {...props}
        remove={props.remove}
        toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
      />

      <DialogTermsCond
        modalTermsCond={modalTermsCond}
        openModalTermsCond={openModalTermsCond}
      />
    </div>
  );
}

export { SignatureRequestView as default };
